(function () {
  function webengageOnReady(cb, attempt) {
    attempt = attempt || 0;
    if (typeof webengage !== 'undefined' && typeof webengage.onReady === 'function') {
      webengage.onReady(cb);
      return;
    }
    if (attempt > 50) return;
    setTimeout(function () {
      webengageOnReady(cb, attempt + 1);
    }, 100);
  }

  function toHttpsUrl(url) {
    const value = String(url || '').trim();
    if (!value) return '';
    if (value.indexOf('//') === 0) return 'https:' + value;
    if (value.indexOf('http://') === 0) return 'https://' + value.slice(7);
    return value;
  }

  function trackWeEvent(eventName, eventData) {
    if (window.Shopify && Shopify.designMode) return;
    webengageOnReady(function () {
      if (typeof webengage !== 'undefined' && typeof webengage.track === 'function') {
        webengage.track(eventName, eventData);
      }
    });
  }

  function getSelectedVariantId(product) {
    const input = document.querySelector(
      '.product-information [name="id"], product-form [name="id"], .product-details [name="id"]'
    );
    if (input && input.value) return String(input.value);
    return String(product.variantId || '');
  }

  function getCurrentVariant(product) {
    const selectedId = getSelectedVariantId(product);
    const match = (product.variants || []).find(function (variant) {
      return String(variant.id) === selectedId;
    });
    return (
      match || {
        id: product.variantId,
        title: product.variantTitle,
        price: product.price,
        image: product.image,
      }
    );
  }

  function getProductPayload(includeRating) {
    const product = window.__WE_PRODUCT;
    if (!product) return null;

    const variant = getCurrentVariant(product);
    const payload = {
      'Product ID': String(product.productId || ''),
      'Product Type': String(product.productType || ''),
      Image: toHttpsUrl(variant.image || product.image || ''),
      Price: Number(variant.price != null ? variant.price : product.price) || 0,
      Title: String(product.title || ''),
      'Variant ID': String(variant.id || product.variantId || ''),
      'Variant Title': String(variant.title || product.variantTitle || ''),
    };

    if (includeRating) {
      payload.Rating = Number(product.rating) || 0;
    }

    return payload;
  }

  function trackProductEvent(eventName, includeRating) {
    const payload = getProductPayload(includeRating);
    if (!payload) return;
    trackWeEvent(eventName, payload);
  }

  let lastProductImageTrack = { key: '', at: 0 };

  function resolveImageClicked(el) {
    if (!el) return '';
    const img = el.querySelector('img.product-media__image') || el.querySelector('img');
    return img ? toHttpsUrl(img.currentSrc || img.src || '') : '';
  }

  function trackProductImageViewed(imagePosition, imageClicked) {
    const product = window.__WE_PRODUCT;
    if (!product) return;

    const position = String(imagePosition || '');
    const clicked = toHttpsUrl(imageClicked);
    const key = position + '|' + clicked;
    const now = Date.now();
    if (key === lastProductImageTrack.key && now - lastProductImageTrack.at < 500) return;
    lastProductImageTrack = { key: key, at: now };

    const variant = getCurrentVariant(product);
    trackWeEvent('Product Image Viewed', {
      'Product ID': String(product.productId || ''),
      'Product Type': String(product.productType || ''),
      Price: Number(variant.price != null ? variant.price : product.price) || 0,
      Title: String(product.title || ''),
      'Variant ID': String(variant.id || product.variantId || ''),
      'Variant Title': String(variant.title || product.variantTitle || ''),
      'Image Position': position,
      'Image clicked': clicked,
    });
  }

  function itemIndex(el) {
    if (!el || !el.parentElement) return 0;
    return Array.prototype.indexOf.call(el.parentElement.children, el);
  }

  function trackProductImageClick(event) {
    const target = event.target;
    if (
      target.closest(
        'slideshow-controls, slideshow-arrows, .dialog-zoomed-gallery__close-button, .dialog-zoomed-gallery'
      )
    ) {
      return;
    }

    const zoomThumb = target.closest('.dialog-thumbnails-list__thumbnail');
    if (zoomThumb) {
      trackProductImageViewed(String(itemIndex(zoomThumb) + 1), resolveImageClicked(zoomThumb));
      return;
    }

    const slide = target.closest('slideshow-slide');
    if (slide) {
      trackProductImageViewed(String(itemIndex(slide) + 1), resolveImageClicked(slide));
      return;
    }

    const gridItem = target.closest('.media-gallery__grid > li');
    if (gridItem) {
      trackProductImageViewed(String(itemIndex(gridItem) + 1), resolveImageClicked(gridItem));
    }
  }

  function inferBannerCategory(position) {
    const value = String(position || '').toLowerCase();
    if (value.indexOf('hero') !== -1) return 'Hero';
    if (value.indexOf('layered') !== -1) return 'Layered Slideshow';
    if (value.indexOf('slideshow') !== -1) return 'Slideshow';
    if (value.indexOf('slider') !== -1) return 'Slider';
    if (value.indexOf('announcement') !== -1) return 'Announcement';
    if (value.indexOf('collection links') !== -1) return 'Collection Links';
    if (value.indexOf('collection') !== -1) return 'Collection';
    return 'Banner';
  }

  function trackBanner(bannerEl) {
    const position = String(bannerEl.getAttribute('data-we-banner-position') || '');
    let name = String(bannerEl.getAttribute('data-we-banner-name') || '').trim();
    let category = String(bannerEl.getAttribute('data-we-banner-category') || '').trim();

    if (!name) {
      const img = bannerEl.querySelector('img');
      name = String((img && (img.getAttribute('alt') || img.getAttribute('aria-label'))) || '').trim();
    }

    if (!name) {
      const hiddenLabel = bannerEl.querySelector('.visually-hidden');
      name = String((hiddenLabel && hiddenLabel.textContent) || '').replace(/\s+/g, ' ').trim();
    }

    if (!name) name = position;
    if (!category) category = inferBannerCategory(position);

    trackWeEvent('Banner Clicked', {
      'Banner Position': position,
      'Banner ID': String(bannerEl.getAttribute('data-we-banner-id') || ''),
      'Banner Name': name,
      'Banner Category': category,
      'Page URL': window.location.href,
    });
  }

  function isProductCardReview(el) {
    return Boolean(
      el.closest(
        'product-card, .product-card, .resource-list__item, .predictive-search-results__card, .product-recommendations'
      )
    );
  }

  function isBannerControl(el) {
    return Boolean(
      el.closest(
        'slideshow-arrows, slideshow-controls, .slick-arrow, .slick-dots, .announcement-bar__slider slideshow-arrows'
      )
    );
  }

  function getFooterName(clickable) {
    const explicit = clickable.getAttribute('data-we-footer-name');
    if (explicit && explicit.trim()) return explicit.trim();

    const aria = clickable.getAttribute('aria-label');
    if (aria && aria.trim()) return aria.trim();

    const img = clickable.querySelector('img');
    if (img) {
      const alt = String(img.getAttribute('alt') || '').trim();
      if (alt) return alt;
    }

    return String(clickable.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function trackFooter(event) {
    const footer = event.target.closest('[data-we-footer]');
    if (!footer) return;

    const clickable = event.target.closest('a, button, summary');
    if (!clickable || !footer.contains(clickable)) return;

    const name = getFooterName(clickable);
    if (!name) return;

    trackWeEvent('Footer Clicked', {
      'Footer Name': name,
    });
  }

  document.addEventListener('click', function (event) {
    const accordionHeader = event.target.closest('[data-we-event]');
    if (accordionHeader) {
      const eventName = accordionHeader.getAttribute('data-we-event');
      if (eventName) trackProductEvent(eventName, false);
      return;
    }

    const reviewBtn = event.target.closest('.cstm-jdgm-reviewstop');
    if (reviewBtn && !isProductCardReview(reviewBtn)) {
      trackProductEvent('Review Button Clicked', true);
      return;
    }

    if (window.__WE_PRODUCT && event.target.closest('media-gallery')) {
      trackProductImageClick(event);
    }

    if (isBannerControl(event.target)) return;

    const bannerEl = event.target.closest('[data-we-banner]');
    if (bannerEl) {
      trackBanner(bannerEl);
    }

    trackFooter(event);
  });

  if (window.__WE_PRODUCT) {
    document.addEventListener('slideshow:select', function (event) {
      if (!event.target.closest || !event.target.closest('media-gallery')) return;
      const detail = event.detail;
      if (!detail || !detail.userInitiated || detail.index === detail.previousIndex) return;
      trackProductImageViewed(String(detail.index + 1), resolveImageClicked(detail.slide));
    });

    document.addEventListener('zoom-media:selected', function (event) {
      const index = event.detail && event.detail.index;
      if (index == null) return;
      const list = event.target.querySelector && event.target.querySelector('.dialog-zoomed-gallery');
      const item = list && list.children[index];
      trackProductImageViewed(String(index + 1), resolveImageClicked(item));
    });
  }

  document.addEventListener('variant:update', function (event) {
    const product = window.__WE_PRODUCT;
    const variant = event.detail && event.detail.resource;
    if (!product || !variant) return;

    product.variantId = String(variant.id || product.variantId || '');
    product.variantTitle = variant.title || product.variantTitle || '';
    const match = (product.variants || []).find(function (item) {
      return String(item.id) === String(variant.id);
    });
    if (match) {
      product.variantTitle = match.title;
      product.price = match.price;
      product.image = match.image;
    }
  });
})();
